var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:['scroll-btn', {jump: _vm.animate}],attrs:{"color":_vm.color,"icon":"","aria-label":"scroll down"},on:{"click":_vm.clicked}},[_c('v-icon',{staticClass:"icon-3xl"},[_vm._v("mdi-chevron-down-circle-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }